var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{'icon-large': _vm.large, 'icon-small': _vm.small}},[_c('i',{staticClass:"fa fa-spin",class:_vm.icon}),(!!_vm.$slots.default)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }